module.exports = __webpack_public_path__ + "img/black_leather_suit-400x520.729e46b5.jpg";